import Vue from "vue";
import App from "./App.vue";
import router from './router'
import store from './store'
// import * as firebase from "firebase";
import './assets/tailwind.css'
import Vuelidate from 'vuelidate'
import firebase from '@/utils/firebase'

Vue.use(Vuelidate)
Vue.use(require('vue-moment'));

Vue.config.productionTip = false;


// const configOptions = {
//   apiKey: "AIzaSyCIo2GmJ4mT8L_aXN4im486jtva9Hq5VvU",
//   authDomain: "convodo2.firebaseapp.com",
//   databaseURL: "https://convodo2.firebaseio.com",
//   projectId: "convodo2",
//   storageBucket: "convodo2.appspot.com",
//   messagingSenderId: "974936691702",
//   appId: "1:974936691702:web:482f43ca7ffa283db4add7",
//   measurementId: "G-MDZ0N5RVGZ"
// };
//
// firebase.initializeApp(configOptions);

firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);
  // store.dispatch("bindConversations");
  // console.log(user)
});




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
